export default __webpack_public_path__ + "static/media/Flag_of_Laos.417e7fa7.svg";